import { render, staticRenderFns } from "./popper.vue?vue&type=template&id=9cdfa130"
import script from "./popper.vue?vue&type=script&lang=js"
export * from "./popper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports